import { Button, Dropdown, Form } from "antd";
import { CheckOutlined, PlusCircleOutlined } from "@ant-design/icons";
import uuid from "react-uuid";
import { BetaSchemaForm } from "@ant-design/pro-components";
import {
    buildSchemaColumnsAutomation
} from "../../../../../../../components/Utils/formColumns";
import { recordFieldKey } from "../../../Snippets/fieldPath";
import { useEffect } from "react";

export const RecordForm = ({ value, handleChangeAll, fields = [], disable = false, fieldName }) => {
    const [form] = Form.useForm();

    const handleClickMenu = (field) => {
        if (value) {
            const fields = (value.fields) ? [...value.fields] : [];
            const index = checkIfisAdded(field, true)
            if (index > -1) {
                fields.splice(index, 1);
            } else {
                const item = {
                    form: field.fieldProps._index,
                    id: field.fieldProps._id,
                    name: field.fieldProps.field,
                    value: null
                }
                fields.push(item);
            }
            handleChangeAll('fields', fields);
        }

    }

    const checkIfisAdded = (field, returnIndex = false) => {
        if (value && value.fields) {
            const index = value.fields.findIndex(item => item.id === field.value);

            if (returnIndex) {
                return index;
            } else {
                return index > -1;
            }
        }
        return false;
    };

    const isRequired = (field) => !!(field.required ?? field.fieldProps?.requiredField);

    const menuItems = (fields || []).filter(value => value && value.fieldProps && (!value.fieldProps.hasOwnProperty('isReadOnly') || !value.fieldProps.isReadOnly))
        .map((value) => ({
            key: uuid(),
            icon: checkIfisAdded(value) ? <CheckOutlined /> : null,
            // `required` é a propriedade montada em transformedFields; o `requiredField`
            // do formulário fica como fallback para itens vindos direto da API.
            label: <>{value.label} ({value.typeText}) - {isRequired(value) ? "Obrigatório" : "Não Obrigatório"}</>,
            onClick: () => handleClickMenu(value),
        }));

    useEffect(() => {
        if (value && value.fields) {
            const values = value.fields.reduce((acc, item, index) => {
                if (item.hasOwnProperty('value')) {
                    acc[recordFieldKey(item.id, item.name)] = item.value;
                }
                return acc;
            }, {});
            form.setFieldsValue(values);
        }
    }, [form, value]);

    const getValues = () => {
        if (value && value.fields && fields && fields.length > 0) {
            return fields.map(field => {
                // As colunas são exibidas na ordem do formulário, mas os valores ficam
                // guardados em value.fields na ordem de inclusão. Levamos a identidade
                // do campo (`id`, com o índice como último recurso) para que os editores
                // em modal (raio, data, seletores) apontem para o campo certo mesmo
                // após adicionar ou remover campos.
                const valueIndex = checkIfisAdded(field, true);
                if (valueIndex > -1) {
                    return {
                        ...field.fieldProps,
                        _valueIndex: valueIndex,
                        _valueId: value.fields[valueIndex].id
                    };
                }
                return null;
            }).filter(item => item);
        }
        return []
    }

    const columns = buildSchemaColumnsAutomation(form, getValues(), `${fieldName}.fields`)

    function handleOnChangeValue() {
        if (!value) return;

        const values = form.getFieldsValue();
        const currentNames = new Map(
            (fields || [])
                .filter(item => item && item.fieldProps && item.fieldProps._id)
                .map(item => [item.fieldProps._id, item.fieldProps.field])
        );

        const updatedFields = value.fields.map(item => {
            const key = recordFieldKey(item.id, item.name);
            // O formulário só devolve os campos que ele tem. Um campo gravado que
            // não virou coluna — porque foi removido do formulário de origem, ou
            // porque os campos ainda não terminaram de carregar — voltava aqui
            // como `undefined` e apagava o valor gravado. Fora do formulário,
            // fica como está.
            if (!Object.prototype.hasOwnProperty.call(values, key)) {
                return item;
            }
            const newValue = values[key];
            if (newValue !== item.value) {
                // O `name` gravado é só rótulo (o back-end grava pelo `id`), mas
                // é ele que nomeia o campo no histórico do registro: aproveita a
                // edição para acompanhar um renome do formulário de origem.
                return { ...item, name: currentNames.get(item.id) ?? item.name, value: newValue };
            }
            return item;
        });

        if (updatedFields.some((item, index) => item.value !== value.fields[index].value)) {
            handleChangeAll('fields', updatedFields);
        }
    }


    return (<div className="ae-field">
        <label className="ae-label">Campos a preencher</label>
        {columns.length > 0 ? (
            <BetaSchemaForm
                form={form}
                layout="vertical"
                layoutType={"Form"}
                columns={columns}
                submitter={false}
                onValuesChange={handleOnChangeValue}
            >
            </BetaSchemaForm>
        ) : (
            // Estado vazio explícito: antes só sobrava o botão verde solto, sem
            // dizer que nenhum campo tinha sido escolhido ainda.
            <div className="ae-empty">
                {disable
                    ? "Selecione um formulário para escolher os campos."
                    : "Nenhum campo selecionado. Adicione os campos que esta ação deve preencher."}
            </div>
        )}
        <Dropdown
            disabled={disable}
            placement="bottomCenter"
            arrow
            menu={{ items: menuItems }}
        >
            <Button className="ae-add-field" type="dashed" icon={<PlusCircleOutlined />}>Adicionar campos</Button>
        </Dropdown>
    </div>)
}
